/*
Version 0.140

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2019.

!Changelog

2020
	17-02-2020
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_scroller = {};

(function(){
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function() {
			
		if(
			url[2] == 'route' ||
			url[2] == 'openingstijden' ||
			url[2] == 'opening-times'
		) {

			specific_scroller.scroll2(
				'js-scroll-2-come',
				50,
				30
			);

		}

		if(
			url[5] == 'tickets'
		) {

			specific_scroller.scroll2(
				'js-scroll-2-tickets',
				100,
				80
			);

		}
		
	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	/*
	Scroll
	*/
	this.scroll2 = function(
		_class,
		_marge_desktop,
		_marge_mobile
	) {
		
		var _offsetTop = $('.' + _class).offset().top;

		var _marge = _marge_desktop;
		if($(window).width() < 500) {
			_marge = _marge_mobile;
		}

		$('html, body').stop().animate({
			scrollTop: _offsetTop - _marge
		}, 500);

	};

}).apply(specific_scroller); 